import React from 'react';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import { Alert, Badge, Layout, Radio, Button, Icon, Result } from 'antd';
import get from 'lodash/get';

import AdminHeader from '../../components/AdminHeader/AdminHeader';
import Footer from '../../components/Footer/Footer';

import isAuthenticated from '../../utils/isAuthenticated';
import { logout } from "../../reducers/user/actions";
import { trainingGetRequest, trainingStartRequest, trainingCheckRequest } from "../../api/requests";

import classes from './Training.css';

const { Content } = Layout;

class Training extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      answer: null,
      answerResult: null,
      is_completed: false,
      is_passed: false,
      current_question: {},
      next_question: {},
      token: null,
      preview_correct_answer: null,
      isLoading: true,
      isLoadingStep: false,
      statusResult: null,
      total_questions: 10,
      question_number: 1,
      total_q: 10,
      q_number: 1,
    };
  }

  async componentDidMount() {
    try {
      const { data } = await trainingGetRequest();

      if (get(data, 'token')) {
        this.setState({
          token: get(data, 'token'),
          is_completed: get(data, 'is_completed'),
          is_passed: get(data, 'is_passed'),
          current_question: get(data, 'current_question'),
          question_number: get(data, 'question_number'),
          total_questions: get(data, 'total_questions'),
        });
      }
    } catch (e) { if (get(e, 'response.status') === 401) { this.props.logout();  return; } this.setState({ statusResult: { type: 'error', message: get(e, 'response.data.error') } }) }

    this.setState({ isLoading: false });
  }

  startQuiz = async () => {
    this.setState({ isLoading: true });

    try {
      const { data } = await trainingStartRequest();

      if (get(data, 'token')) {
        this.setState({
          token: get(data, 'token'),
          is_completed: get(data, 'is_completed'),
          is_passed: get(data, 'is_passed'),
          current_question: get(data, 'current_question'),
          question_number: get(data, 'question_number'),
          total_questions: get(data, 'total_questions'),
          statusResult: null,
        });
      }
    } catch (e) { if (e.response.status === 401) { this.props.logout();  return; } console.log(e); }

    this.setState({ isLoading: false });
  };

  verifyQuiz = async () => {
    const { token, current_question, answer } = this.state;
    this.setState({ isLoadingStep: true });

    try {
      const { data } = await trainingCheckRequest({ token, q_id: current_question.id, q_ans: answer });

      if (get(data, 'token')) {
        this.setState({
          token: get(data, 'token'),
          is_completed: get(data, 'is_completed'),
          is_passed: get(data, 'is_passed'),
          next_question: get(data, 'current_question'),
          q_number: get(data, 'question_number'),
          total_q: get(data, 'total_questions'),
          preview_correct_answer: get(data, 'preview_correct_answer'),
          answerResult: {
            type: get(data, 'preview_correct_answer') ===  answer ? 'success' : 'error',
            message: get(data, 'preview_correct_answer') ===  answer ? 'Correct' : `Correct answer is: ${get(current_question, get(data, 'preview_correct_answer'))}`,
          },
        });
      }

    } catch (e) { if (e.response.status === 401) { this.props.logout();  return; } console.log(e); }

    this.setState({ isLoadingStep: false });
  };

  nextStep = () => {
    this.setState(state => ({
      current_question: state.next_question,
      next_question: {},
      question_number: state.q_number,
      total_questions: state.total_q,
      answer: null,
      answerResult: null,
      statusResult: null,
    }));
  };

  onChangeAnswer = e => {
    this.setState({ answer: e.target.value, });
  };

  render() {
    const { answer, answerResult, current_question, is_completed, isLoading, is_passed, statusResult, total_questions, question_number } = this.state;

    return (
      <div style={{ backgroundColor: '#FAFAFA' }}>
        <Helmet>
          <title>Trial Management Portal: Settings</title>
        </Helmet>
        <Layout className={classes.parentContainer}>
          <AdminHeader />
          <Content className={classes.content}>
            <h3 className="headline-default">Training</h3>

            {isLoading && <Icon type="loading" />}

            {statusResult && (<Alert message={statusResult.message} type={statusResult.type} className={classes.submitResult} />)}

            {!isLoading && !get(current_question, 'id') && !is_completed && !statusResult && <div style={{ margin: '10px 0 0' }}>
              <Button type="primary" onClick={this.startQuiz}>Start quiz</Button>
            </div>}

            {!isLoading && get(current_question, 'id') && <div>
              <Badge count={`Question ${question_number} from ${total_questions}`} style={{ backgroundColor: '#2968AE', margin: '0 0 10px' }} />
              <br/>
              <div>{get(current_question, 'question')}</div>
              <Radio.Group
                disabled={!!answerResult}
                options={Object.keys(current_question).filter(item => item.includes('answer')).map(value => ({ label: current_question[value], value }) )}
                onChange={this.onChangeAnswer}
                value={answer}
              />
            </div>}

            {answerResult && (<Alert message={answerResult.message} type={answerResult.type} className={classes.submitResult} />)}

            <div className={classes.submitWrapper}>
              {!answerResult && get(current_question, 'id') && <Button type="primary" onClick={this.verifyQuiz}>Answer</Button>}
              {answerResult && <Button type="primary" onClick={this.nextStep}>{is_completed ? 'Finish' : 'Next step'}</Button>}
            </div>


            {is_completed && !get(current_question, 'id') && <React.Fragment>
              {is_passed ? (
                <Result
                  status="success"
                  title="Congratulations on passing the AcT Training!"
                  subTitle="Your training certificate has automatically been uploaded to the system. Please log out and you will receive an e-mail with instructions on how to use your active AcT account!"
                />
              ) : (
                <Result
                  status="error"
                  title="Testing Failed"
                  subTitle="Testing has been failed"
                  extra={[
                    <Button type="primary" key="console" onClick={this.startQuiz}>
                      Retry
                    </Button>,
                  ]}
                />
              )}
            </React.Fragment>}

        </Content>
          <Footer noAdminLink />
        </Layout>
      </div>
    );
    }
}

const mapStateToProps = _ => ({});

const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(Training));



// WEBPACK FOOTER //
// ./src/containers/Training/Training.js